import {
  BackgroundImage,
  DescriptionContainer,
  ImageContainer,
  MainContainer,
  NameContainer,
  PriceContainer,
  MenuItemContainer,
  TextTopBox,
  SoldOutContainer,
  SoldOutCircle,
  SoldOutText,
  ImageSkeleton,
} from "./menu-item.styles.jsx";
import { useState } from "react";
import { TransitionsModal } from "../menu-item-modal/menu-item-modal.component.jsx";
import { BundleModal } from "../bundle-modal/bundle-modal.component.jsx";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../utils/firebase/firebase.utils";
import { dishSoldOut } from "../../constants.ts";
import { useMenuItemCardTheme } from "./useMenuItemCardTheme.js";
import { isDishPromoUnavailable } from "../../utils/promoCheck";
import { formatDishItemPriceDisplay } from "../../utils/variantPricing";

const DefaultMenuItem = ({ product, kitchen }) => {
  const {
    textBody,
    backgroundPrimary,
    cardBackground,
    brandTertiary,
    skeletonBase,
    skeletonHighlight,
  } = useMenuItemCardTheme();

  const [showModal, setShowModal] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const isBundleItem =
    product?.isBundle === true && Boolean(product?.bundleConfig);

  const toggleShowModal = () => {
    logEvent(analytics, "dish_viewed", {
      kitchenName: kitchen?.kitchenName,
    });
    setShowModal((p) => !p);
  };

  const {
    dishName,
    dishDescription,
    dishPrice,
    remoteUri,
    dishStatus,
    stockDetails,
    variants,
  } = product;
  const isDishOutOfStock =
    stockDetails && stockDetails.isEnabled && stockDetails.quantity === 0;
  const soldOut = dishStatus === dishSoldOut || isDishOutOfStock;
  const promoUnavailable = isDishPromoUnavailable(product);
  const isUnavailable = soldOut || promoUnavailable;
  const unavailableLabel = soldOut ? "Sold Out" : "Unavailable";
  const priceDisplay = formatDishItemPriceDisplay(dishPrice, variants);

  return (
    <>
      <MenuItemContainer onClick={toggleShowModal} cardBackground={cardBackground}>
        <MainContainer>
          <TextTopBox imageUrl={remoteUri}>
            <NameContainer soldOut={isUnavailable} brandTertiary={brandTertiary}>
              {dishName}
            </NameContainer>
            <DescriptionContainer soldOut={isUnavailable} textBody={textBody}>
              {dishDescription ? dishDescription.replaceAll("\\n", "\n") : ""}
            </DescriptionContainer>
          </TextTopBox>
          <div style={{ flex: 1, alignItems: "flex-end", display: "flex" }}>
            <div style={{ alignItems: "center", flex: 1, display: "flex" }}>
              <PriceContainer soldOut={isUnavailable} textBody={textBody}>
                {priceDisplay}
              </PriceContainer>
              {isUnavailable && (
                <SoldOutContainer>
                  <SoldOutCircle textBody={textBody} />
                  <SoldOutText
                    textBody={textBody}
                    backgroundPrimary={backgroundPrimary}
                  >
                    {unavailableLabel}
                  </SoldOutText>
                </SoldOutContainer>
              )}
            </div>
          </div>
        </MainContainer>
        {remoteUri && (
          <ImageContainer>
            <ImageSkeleton
              hidden={imageLoaded}
              skeletonBase={skeletonBase}
              skeletonHighlight={skeletonHighlight}
            />
            <BackgroundImage
              className="image"
              src={remoteUri}
              alt={`${dishName}`}
              loaded={imageLoaded}
              soldOut={isUnavailable}
              loading="lazy"
              decoding="async"
              onLoad={() => setImageLoaded(true)}
              onError={() => setImageLoaded(true)}
            />
          </ImageContainer>
        )}
      </MenuItemContainer>
      {showModal &&
        (isBundleItem ? (
          <BundleModal
            product={product}
            showModal={showModal}
            toggleShowModal={toggleShowModal}
            kitchen={kitchen}
          />
        ) : (
          <TransitionsModal
            product={product}
            showModal={showModal}
            toggleShowModal={toggleShowModal}
            kitchen={kitchen}
          />
        ))}
    </>
  );
};

export default DefaultMenuItem;
